export enum ReactionType {
  ReactionLike = 'ReactionLike',
  ReactionFavorite = 'ReactionFavorite',
  ReactionRecycling = 'ReactionRecycling',
  ReactionDislike = 'ReactionDislike',
  ReactionNeutral = 'ReactionNeutral',
  ReactionAngry = 'ReactionAngry',
}
